import React from "react";
import { Trans } from "@lingui/macro";
import { Button } from "../../../../UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import DateFilter from "../../../../UI/DateFilter/DateFilter";
import { typeRefundsArchiveFilters } from "../../../../../model/dashboardRefundsArchive/reducer";
import { selectRefundsArchiveFilters } from "../../../../../model/dashboardRefundsArchive/selectors";
import { dRefundsArchiveSetFiltersAC } from "../../../../../model/dashboardRefundsArchive/actionCreators";
import dayjs from "dayjs";

export type typeDRefundsFilters = {
  setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>;
  setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>;
};

export const Filters: React.FC<typeDRefundsFilters> = ({
  setOpenFilterBar,
  setIsActiveFilters,
}) => {
  const dispatch = useDispatch();

  const filters = useSelector(selectRefundsArchiveFilters);

  let dateTo = "";
  if (filters.date?.to) {
    dateTo = dayjs(filters.date.to.slice(0, 10)).format("YYYY-MM-DD");
  }
  const [toValue, setToValue] = React.useState(dateTo);

  let dateFrom = "";
  if (filters.date?.from) {
    dateFrom = dayjs(filters.date.from.slice(0, 10)).format("YYYY-MM-DD");
  }
  const [fromValue, setFromValue] = React.useState(dateFrom);

  const checkIsChangedFiltersHandler = (
    newFilters: typeRefundsArchiveFilters,
  ): boolean => {
    return !(
      newFilters.date?.to === filters.date?.to &&
      newFilters.date?.from === filters.date?.from
    );
  };

  const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let b = null;
    if (toValue !== "") {
      b = dayjs(toValue).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    }

    let a = null;
    if (fromValue !== "") {
      a = dayjs(fromValue).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    }

    const newFilters: typeRefundsArchiveFilters = {
      date: a === "" && b === "" ? null : { from: a, to: b },
    };

    if (checkIsChangedFiltersHandler(newFilters)) {
      dispatch(dRefundsArchiveSetFiltersAC(newFilters));

      setIsActiveFilters(true);
    }

    setOpenFilterBar(false);
  };

  const onRestoreHandler = () => {
    setToValue("");
    setFromValue("");

    setIsActiveFilters(false);

    dispatch(
      dRefundsArchiveSetFiltersAC({
        date: null,
        receiptNumber: null,
      }),
    );
  };

  return (
    <>
      <form onSubmit={(e) => onSubmitHandler(e)}>
        <div className="flex flex-col gap-4">
          <DateFilter
            toValue={toValue}
            minData="2020-01-01"
            fromValue={fromValue}
            setToValue={setToValue}
            label={<Trans>Date</Trans>}
            setFromValue={setFromValue}
            maxData={dayjs().format("YYYY-MM-DD")}
          />

          <div className="flex mt-4 gap-4 flex-col sm:flex-row">
            <Button
              type="button"
              secondary={true}
              buttonClassName="w-full"
              onClick={onRestoreHandler}
              label={<Trans>Clear</Trans>}
            />
            <Button
              type="submit"
              buttonClassName="w-full"
              label={<Trans>Apply</Trans>}
            />
          </div>
        </div>
      </form>
    </>
  );
};
